export default __webpack_public_path__ + "static/media/chevron-blue.21c16af4.svg";